<template>
  <layout-basic>
    <page-hero
      title="Downloads"
      lead="Helpful downloads to support your learning strategy."
    />

    <section class="resource-shell">
      <v-container>
        <p class="resource-shell__note">
          Downloadable resources are being prepared. Check back soon, or talk to
          our team if you need something specific.
        </p>
      </v-container>
    </section>

    <point-grid :points="points" :columns="2" tint />
    <standard-cta />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Downloads',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Downloads | IMPROVE',
      description: 'Helpful downloads to support your learning strategy.',
      path: '/resources/downloads',
    });
  },
  data() {
    return {
      points: [
        'Learning strategy checklists',
        'Onboarding planners',
        'Compliance trackers',
        'Buyer’s guides for SMEs',
      ],
    };
  },
};
</script>

<style scoped>
.resource-shell {
  padding: 8px 0 24px;
}

.resource-shell__note {
  text-align: center;
  max-width: 560px;
  margin: 0 auto 8px;
  color: var(--brand-grey, #6b7280);
  font-size: 15px;
  line-height: 1.5;
}
</style>
